import { MajorMilestoneTypeBase } from './base/major-milestone-type-base';

export class MajorMilestoneType extends MajorMilestoneTypeBase { }